//RTL対応
export const detectTextDirection = (text: string): "rtl" | "ltr" => {
  // アラビア語、ヘブライ語、ペルシャ語などのRTL文字
  const rtlRegex = /[\u0600-\u06FF\u0750-\u077F\u08A0-\u08FF\uFB50-\uFDFF\uFE70-\uFEFF\u0590-\u05FF\uFB1D-\uFB4F]/;
  return rtlRegex.test(text) ? "rtl" : "ltr";
};
